import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  background-color: black;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  .topNav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: ${({ theme }) => theme.spacing.xs};
    /* border: 5px solid orange; */
  }
  .bottomNav {
    padding-block: ${({ theme }) => theme.spacing.s};
    /* border: 1px solid red; */
  }
  .links {
    display: flex;
    justify-content: space-evenly;
    gap: ${({ theme }) => theme.spacing.s};
    width: 100%;
    /* border: 1px solid green; */
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }
  .links a:hover {
    color: ${({ theme }) => theme.colors.yellow3};
  }
  .links a:active {
    color: ${({ theme }) => theme.colors.orange4};
  }
  .first {
    /* width: 15%; */
    visibility: hidden;
    /* border: 5px solid red; */
    width: 30%;
    /* padding: ${({ theme }) => theme.spacing.m}; */
  }
  .second img {
    height: 80px;
    /* border: 5px solid orange; */
    width: 180px;
    margin-block: ${({ theme }) => theme.spacing.xxs};
  }
  .third {
    //width: 10%;
    display: flex;
    min-width: 30%;
    align-items: center;
    justify-content: end;
    gap: ${({ theme }) => theme.spacing.m};
    /* width: 15%; */
    padding-right: ${({ theme }) => theme.spacing.xs};
    /* border: 5px solid yellow; */
  }

  .third button,
  .third svg {
    margin-left: ${({ theme }) => theme.spacing.s};
  }
  .desktop {
    /* border: 1px solid green; */
    display: flex;
    gap: ${({ theme }) => theme.spacing.xs};
  }
  .mobile {
    /* border: 1px solid blue; */
    display: none;
    visibility: collapse;
  }
  @media screen and (width <= 1400px) {
    .topNav {
      padding: ${({ theme }) => theme.spacing.xxs};
    }
    .bottomNav {
      display: none;
      padding-block: 0rem;
    }
    .first {
      visibility: visible;
    }
    .second img {
      height: 80px;
      width: 160px;
    }
    .desktop {
      /* border: 1px solid pink; */
      display: none;
      visibility: collapse;
    }
    .mobile {
      display: flex;
      /* border: 1px solid orange; */
      visibility: visible;
      gap: ${({ theme }) => theme.spacing.m};
    }
  }
  @media screen and (width <= 768px) {
    overflow-x: hidden;
    .second img {
      height: 60px;
      width: 120px;
    }
  }

  /* Dropdown button */
  .dropbtn {
    background-color: black;
    color: ${({ theme }) => theme.colors.grey1};
    padding: 5px;
    //font-size: 16px;
    //border: none;
  }
  .dropdown {
    position: relative;
    display: inline-block;
  }
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: ${({ theme }) => theme.colors.offWhite};
    min-width: 160px;
    z-index: 2;
    border-radius: ${({ theme }) => theme.borderRadius};
  }

  .dropdown-content a {
    color: black;
    padding: 12px 16px;
    display: block;
  }

  .dropdown-content a:hover {
    background-color: ${({ theme }) => theme.colors.grey5};
    border-radius: ${({ theme }) => theme.borderRadius};
  }
  .dropdown:hover .dropdown-content {
    display: block;
  }
  @media screen and (width <= 375px) {
    .second img {
      height: 50px;
      width: 100px;
    }
  }
`;
